import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { pageHandler } from "@/lib/pages-handler";
import { _getSiteConfiguration } from "@/dato-api/site-config-cache";
import { ErrorHandler } from "@/components/Organisms/ErrorHandler";
import { useRouter } from "next/router";
import { useEffect } from "react";

/**
 *
 * @param {array} siteConfig Site configuration necessary to Layout build Header and Footer
 * @param {array} data Homepage data
 * @param {array} relations Sections relation
 * @returns JSX Element
 *
 */
export default function Index({ siteConfig }) {
  const router = useRouter();
  // redirect to home
  useEffect(() => {
    router.push("/");
  });

  return (
    <ErrorHandler
      bg={siteConfig?.backgroundImage}
      copy={siteConfig?.errorFourOFourMessage}
      color={siteConfig?.errorTextColor}
    />
  );
}

export async function getStaticProps(context) {
  const siteConfig = await _getSiteConfiguration(context.locale, false).then(
    (result) => result.siteConfiguration
  );

  const result = [];
  const pageData = await pageHandler(
    context,
    serverSideTranslations,
    result,
    ""
  );

  return {
    props: {
      siteConfig: siteConfig,
      ...pageData.sst,
      data: { ...pageData.data },
      preview: pageData.preview,
    },
  };
}
// just ti redeploy
